import { useEffect, useState } from "react";
import { CounterInputEdit } from "../../../EditOnboarding/components/Input/CounterInput/Index";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ReactComponent as GrassIcon } from "../../../../assets/svg/icons/grass.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";
import { ButtonYesOrNo } from "../../../Buttons/ButtonYesOrNo";
import { format } from "date-fns";

interface InfoBrushCuttingProps {
  task: ITaskBrushCutting | undefined;
}


export default function InfoBrushCutting(task: InfoBrushCuttingProps) {
  const [taskBrushCutting, setTaskBrushCutting] = useState<ITaskBrushCutting>();
  useEffect(() => {
    setTaskBrushCutting(task.task)
  }, []);


  return (
    <>
      <div >
        <span>No pasto</span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <GrassIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskBrushCutting?.initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`A tarefa foi iniciada?`} pointed />
        <ButtonYesOrNo onlyResult optionSelected={taskBrushCutting?.initial_hour_meter ? "yes" : "no"} />
      </div>


      {!taskBrushCutting?.initial_hour_meter ?
        taskBrushCutting?.skip_reason ? <MessageBalloon text={`${taskBrushCutting?.skip_reason}`} pointed /> : <></>
        :
        <>
          <MessageBalloon text={`${format(new Date(taskBrushCutting?.start_time || 0), 'dd/MM/yyyy - HH:mm')}`} />

          <MessageBalloon text={`Informar horímetro inicial`} />
          <CounterInputEdit isDisabled defaultValue={taskBrushCutting?.initial_hour_meter || 0} control={undefined} isInline label="h" />


          <ButtonPressed onlyResult optionSelected={1} value={1} text={`Horímetro final`} />

          <MessageBalloon text={`${format(new Date(taskBrushCutting?.end_time || 0), 'dd/MM/yyyy - HH:mm')}`} />

          <MessageBalloon text={`Informar horímetro final`} />
          <CounterInputEdit isDisabled defaultValue={taskBrushCutting?.final_hour_meter || 0} control={undefined} isInline label="h" />
        </>
      }
    </>
  )
}